
export const importAll = (r) => {
  return r.keys().map((item, index) => r(item));
}
